var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-avatar',{staticStyle:{"margin-top":"5px","font-size":"calc(1.5rem) !important"},attrs:{"text":_vm.co_shortName,"size":_vm.p_size,"variant":"light"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }